import { StyleSheet, Text } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'

const styles = StyleSheet.create({
	h1: {
		fontSize: 15,
		fontFamily: 'Inter',
		fontWeight: 'bold',
		marginBottom: 8,
		textAlign: 'left',
	},
})

const H1 = ({ children }: { children: React.ReactNode }) => (
	<ErrorBoundary message={'Error in H1'}>
		<Text style={styles.h1}>{children}</Text>
	</ErrorBoundary>
)

export default H1
